import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import ShipmentAdditionalInfoEditableCell from '../../components/cells/additional-info/shipment-additional-info-editable-cell'

export const additionalInfoColumn: ShipmentColumn = {
    key: 'additionalInfo',
    dataIndex: 'package',
    title: 'Доп.',
    width: 44,
    onCell: onCellStandard,
    render: renderShipment(shipment => <ShipmentAdditionalInfoEditableCell shipment={shipment} />),
}
